"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageFrameConfig = exports.DEFAULT_SERVICE_CONFIG = void 0;
const ab_client_1 = require("@zillow/ab-client");
const config_1 = __importDefault(require("next/config"));
const get_1 = __importDefault(require("lodash/get"));
const merge_1 = __importDefault(require("lodash/merge"));
exports.DEFAULT_SERVICE_CONFIG = {
    deviceType: 'desktop',
    guid: 'local-dev-unique-id',
    loginMemento: '',
    pageFrameConfig: {},
    profiles: undefined,
    requestId: 'B',
    sid: '',
    ssid: '',
    zuid: undefined,
};
/**
 * Get config from request object if available, and merge with default config
 * @param {Object} req
 * @returns {Object}
 */
function getPageFrameConfig(req, { pfsHost, s3sHost } = {}) {
    let { deviceType, guid, loginMemento, profiles, requestId, sid, ssid, zuid } = exports.DEFAULT_SERVICE_CONFIG;
    const nextConfig = (0, config_1.default)() || {};
    const { pfs, pageFrameConfig, s3sConfig } = (0, merge_1.default)(exports.DEFAULT_SERVICE_CONFIG, (0, get_1.default)(nextConfig, 'serverRuntimeConfig.nsa'));
    if (req && req.headers) {
        deviceType = req.headers['x-z-devicecategory'] || deviceType;
        guid = req.headers['x-user-guid'] || guid;
        loginMemento = req.headers['x-z-login-memento'] || loginMemento;
        requestId = req.headers['x-unique-id'] || req.headers['x-user-request-id'] || requestId;
        sid = req.headers['x-z-sid'] || sid;
        ssid = req.headers['x-z-ssid'] || sid;
        zuid = req.headers['x-z-zuid'] || zuid;
        profiles = req.headers['x-z-profiles'] || profiles;
    }
    return {
        deviceType,
        guid,
        loginMemento,
        pageFrameConfig,
        pfsHost: pfsHost || (pfs && (0, ab_client_1.buildEndpoint)(pfs.protocol, pfs.host, pfs.port)),
        profiles,
        requestId,
        s3sHost: s3sHost ||
            (s3sConfig && (0, ab_client_1.buildEndpoint)(s3sConfig.protocol, s3sConfig.host, s3sConfig.port)),
        sid,
        ssid,
        zuid,
    };
}
exports.getPageFrameConfig = getPageFrameConfig;
